module.exports = "<symbol id=\"thebestco-uikit-svg-Sort12\" viewBox=\"0 0 12 12\"><path d=\"M0 0H12V2H0zM0 5H12V7H0zM0 10H12V12H0z\"/></symbol>";